
import React, { useState } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { signInUser } from "auth/service/auth.service";
// reactstrap components
import { Container, Row, Col, Alert } from "reactstrap";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar.js";
import AuthFooter from "components/Footers/AuthFooter.js";

import routes from "routes.js";
import Admin from "./Admin";


const Auth = (props ) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  const [ username, setUserName ] = useState();
  const [ password, setPassword ] = useState();

  const [ token, setToken ] = useState();

  React.useEffect(() => {
    
    return () => {
      
    };
  }, []);



  const handleSubmit = async e => {
    e.preventDefault();
    const token = await signInUser(
      username,
      password
    );
    console.log(token);
    if(token!= null){
     localStorage.setItem('token', token.data.authToken);
     localStorage.setItem('user', JSON.stringify(token.data.user));

     window.location.href = '/adminindex';

    }else{
      
    }
   
  }


  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };


  return (
    <>
    <div className="container position-sticky z-index-sticky top-0">
      <div className="row">
        <div className="col-12">
          {/* Navbar */}
          <nav className="navbar navbar-expand-lg blur border-radius-lg top-0 z-index-3 shadow position-absolute mt-4 py-2 start-0 end-0 mx-4">
            <div className="container-fluid">
              <a
                className="navbar-brand font-weight-bolder ms-lg-0 ms-3 text=align-center"
                href="../pages/dashboard.html"
              >
               TaskPe  - Powered by PollPe...
              </a>
            
             
            </div>
          </nav>
          {/* End Navbar */}
        </div>
      </div>
    </div>
    <main className="main-content  mt-0">
      <section>
        <div className="page-header min-vh-100">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
                <div className="card card-plain">
                  <div className="card-header pb-0 text-start">
                    <h4 className="font-weight-bolder">Sign In</h4>
                    <p className="mb-0">
                      Enter your email and password to sign in
                    </p>
                  
                  </div>
                  <div className="card-body">
                    <form role="form" onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="Username"
                          onChange={e => setUserName(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <input
                          type="password"
                          className="form-control form-control-lg"
                          placeholder="Password"
                          onChange={e => setPassword(e.target.value)}
                        />
                      </div>
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="rememberMe"
                        />
                        <label className="form-check-label" htmlFor="rememberMe">
                          Remember me
                        </label>
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className="btn btn-lg btn-primary btn-lg w-100 mt-4 mb-0"
                        >
                          Sign in
                        </button>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
              <div className="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
                <div
                  className="position-relative h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                  style={{
                    backgroundImage:
                      'url("https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg")',
                    backgroundSize: "cover"
                  }}
                >
                  <span className="mask bg-gradient-primary opacity-6" />
                  <h4 className="mt-5 text-white font-weight-bolder position-relative">
                    "Attention is the new currency"
                  </h4>
                  <p className="text-white position-relative">
                    The more effortless the writing looks, the more effort the
                    writer actually put into the process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </>
  
  );
};

export default Auth;
